/** latest_data が空文字・null・オブジェクト以外のとき false */
export default function hasLatestData(latestData) {
  return (
    latestData !== ''
    && latestData !== null
    && latestData !== undefined
    && typeof latestData === 'object'
  );
}
